<template>
  <div class="q_mar_b100px">
    <div class="q_pad_lr15px q_mar_t15px">
      <div class="q_vertical_left q_mar_b15px">
        <div class="q_inlineblock">
          <van-image class="q_bas_img" fit="cover" :src="user.avatar"/>
        </div>
        <div class="q_mar_l15px q_inlineblock">
          <div class="">
            <span class="q_text_m q_bold" v-text="user.realName">张三</span>
<!--            <span class="q_text_s q_color_gray q_mar_l10px" v-text="user.age+'岁'">24岁</span>-->
            <span class="q_text_s q_color_gray q_mar_l10px" v-text="user.realIdentity">在校生</span>
          </div>
          <div class="q_text_s q_color_gray q_mar_t10px" v-text="user.realPhone">15236589412</div>
<!--          <div class="q_text_s q_color_gray q_mar_t10px">志愿者号：{{ user.volunteerNo }}</div>-->
        </div>
      </div>
      <div class="q_text_l q_bold q_mar_t15px q_mar_b10px">其他信息</div>
    </div>
    <van-cell title="身份证号" :value="user.identity"/>
    <van-cell title="目前学历" :value="user.education"  v-if="user.realIdentity == '已就业'"/>
    <van-cell title="毕业院校" :value="user.school"  v-if="user.realIdentity == '已就业'"/>
    <van-cell title="所学专业" :value="user.subject"  v-if="user.realIdentity == '已就业'"/>
    <van-cell title="就职单位" :value="user.employedUnit"  v-if="user.realIdentity == '已就业'"/>
    <van-cell title="担任职务" :value="user.jobTitle"  v-if="user.realIdentity == '已就业'"/>

    <van-cell title="目前学历" :value="user.education"  v-if="user.realIdentity == '在校生'"/>
    <van-cell title="就读院校" :value="user.school"  v-if="user.realIdentity == '在校生'"/>


<!--    <van-cell title="参与过志愿服务" :value="user.isJoin=='0'?'否':'是'"/>-->
<!--    <van-cell title="参与时长(天)" :value="user.joinDays" v-if="user.isJoin=='1'"/>-->
<!--    <van-cell title="特长及爱好" :value="user.hobby"/>-->
<!--    <div class="q_pad_lr15px">-->
<!--      <p class="q_pad_tb10px q_color_gray">特长及爱好</p>-->
<!--      <p class="q_justify" v-text="user.hobby">-->
<!--        特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好特长及爱好</p>-->
<!--    </div>-->
    <div v-if="user.baseAudit!=null">
      <div class="q_pad_lr15px q_mar_t30px">
        <div class="q_text_l q_bold q_mar_t15px q_mar_b10px">审核信息</div>
      </div>
      <van-cell title="审核结果"
                :value="user.baseAudit.auditState=='0'?'待审核':user.baseAudit.auditState=='1'?'审核通过':'审核不通过'"/>
      <van-cell title="提交时间" :value="user.baseAudit.auditSubmitTime"/>
      <van-cell title="审核时间" :value="user.baseAudit.auditHandleTime"/>
      <div class="q_pad_lr15px">
        <p class="q_pad_tb10px q_color_gray">审核意见</p>
        <p class="q_justify" v-text="user.baseAudit.auditReason">不通过理由不通过理由不通过理由不通过理由不通过理由不通过理由</p>
      </div>
    </div>
    <van-goods-action>
      <!-- 修改按钮，在审核通过或待审核状态出现 -->
      <van-goods-action-icon icon="edit" text="修改资料" @click="goToBasicdata()"/>
      <van-goods-action-button type="danger" color="#ffffff"
                               :text="user.baseAudit.auditState=='0'?'待审核':user.baseAudit.auditState=='1'?'审核通过':'审核不通过'"/>
      <!-- 审核未通过 -->
      <!-- <van-goods-action-button type="danger" color="#ffffff" text="审核未通过" /> -->
    </van-goods-action>
  </div>
</template>

<script>
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Basicd',
  props: {
    msg: String
  },
  data() {
    return {
      user: {
        baseAudit: {
          auditState: '0'
        }
      }
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading('加载个人信息')
    this.$store.dispatch("GetInfo").then(res => {
      this.user = res.data
    }).finally(() => {
      this.$modal.closeLoading()
    })
  },
  methods: {
    goToBasicdata() {
      this.$router.push({
        path: '/mine/Basicdata'
      });
    },
  },
}
</script>
<style scoped="scoped">
.q_bas_img {
  width: 80px;
  height: 80px;
}

.q_bas_img >>> .van-image__img {
  border-radius: 5px;
}

.van-cell__title {
  color: #999999;
}

.van-cell__value {
  color: #333333;
}

>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-goods-action-button {
  color: #999999 !important;
}
</style>
